// src/api.js
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8000";

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (process.env.NODE_ENV !== "production") {
    console.log("API REQUEST ->", `${config.baseURL}${config.url}`);
  }

  return config;
});

// ======================================================
// OFFERINGS
// ======================================================

export const fetchMyOfferings = async () => {
  try {
    return await api.get("/course-offerings/my");
  } catch (e1) {
    try {
      return await api.get("/course-offerings");
    } catch (e2) {
      return await api.get("/course-offerings/assigned");
    }
  }
};

export const fetchOfferingWeeklyProgress = (offeringId) =>
  api.get(`/courses/offerings/${offeringId}/weekly-progress`);

export const fetchOfferingWeeklyPlans = (offeringId) =>
  api.get(`/courses/offerings/${offeringId}/weekly-plans`);

export const fetchOfferingMaterials = (offeringId) =>
  api.get(`/courses/offerings/${offeringId}/materials`);

export const createOfferingMaterial = (offeringId, formData) =>
  api.post(`/courses/offerings/${offeringId}/materials`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const deleteOfferingMaterial = (offeringId, materialId) =>
  api.delete(`/courses/offerings/${offeringId}/materials/${materialId}`);

export const deleteOfferingMaterialFile = (offeringId, materialId, fileId) =>
  api.delete(`/courses/offerings/${offeringId}/materials/${materialId}/files/${fileId}`);

export const bulkAddStudentsToOffering = (offeringId, students) =>
  api.post(`/course-offerings/${offeringId}/students/bulk`, { students });

export const fetchOfferingStudents = (offeringId) =>
  api.get(`/course-offerings/${offeringId}/students`);


// ======================================================
// ASSESSMENTS - OLD COURSE ROUTES
// ======================================================

export const fetchCourseAssessments = (courseId) =>
  api.get(`/courses/${courseId}/assessments`);

export const createAssessment = (courseId, data) =>
  api.post(`/courses/${courseId}/assessments`, data);


// ======================================================
// ASSESSMENTS - OFFERING ROUTES
// ======================================================

export const fetchOfferingAssessments = (offeringId) =>
  api.get(`/offerings/${offeringId}/assessments`);

export const createOfferingAssessment = (offeringId, data) =>
  api.post(`/offerings/${offeringId}/assessments`, data);


// ======================================================
// ASSESSMENT DETAIL
// ======================================================

export const fetchAssessment = (assessmentId) =>
  api.get(`/assessments/${assessmentId}`);

export const updateAssessment = (assessmentId, data) =>
  api.put(`/assessments/${assessmentId}`, data);


// ======================================================
// SUBMISSIONS
// ======================================================

export const bulkUploadMarks = (assessmentId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return api.post(`/assessments/${assessmentId}/submissions/bulk-upload`, formData);
};

export const uploadSolutionFile = (assessmentId, regNo, file) => {
  const formData = new FormData();
  formData.append("reg_no", regNo);
  formData.append("file", file);
  return api.post(`/assessments/${assessmentId}/submissions/file`, formData);
};


// ======================================================
// GRADING AUDIT
// ======================================================

export const runGradingAudit = (assessmentId) =>
  api.post(`/assessments/${assessmentId}/run-grading-audit`);

export const getGradingAudit = (assessmentId) =>
  api.get(`/assessments/${assessmentId}/grading-audit`);

export default api;